import {USER_CATEGORIES} from '@/constants';
import {MyData} from '@/interface';
import {BasicAnalysisResult} from '@/map/@types';
import {ANAYSIS_RESULT_LABELS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {getAreahouseReport, getCompareAvgLevel, getCompareAvgText, getSidoName} from '@/map/utils';
import {withComma} from './common';
import {humanizeNumber} from './number';

const getAverageText = (total: number, avg: number, ctprvn: string) => {
  const compareLevel = getCompareAvgLevel(total, avg);

  return ` (${ctprvn} 평균 대비 ${getCompareAvgText(compareLevel)})`;
};

export const buildAiPromptUserScript = (
  data?: BasicAnalysisResult,
  userProfile?: MyData['profile']
) => {
  if (!data) {
    return null;
  }

  const report = getAreahouseReport(data);
  const script: string[] = ['##상권 정보##'];
  const ctprvn = getSidoName(data.average.sido);
  const average = data.average;

  if (report?.house?.total) {
    const house = report.house;
    let totalText = `배후세대: ${withComma(house.total)}세대`;

    if (average?.[AreaAnalyticsFilter.HOUSE]) {
      totalText += getAverageText(
        house.total as number,
        average[AreaAnalyticsFilter.HOUSE],
        ctprvn
      );
    }

    script.push(totalText);
    script.push(
      Object.entries(house)
        .filter(([key, value]) => key !== 'total' && value > 0)
        .map(([key, value]) => {
          let label = ANAYSIS_RESULT_LABELS[key];

          if (key === AreaAnalyticsFilter.UPCOMMING_APTS) {
            label = '아파트 ' + label;
          }

          return `ㄴ${label} ${withComma(value)}세대`;
        })
        .join('\n')
    );
  }

  if (data.population) {
    let totalText = `거주인구: ${withComma(Math.round(data.population))}명`;

    if (average?.population) {
      totalText += getAverageText(data.population, average.population, ctprvn);
    }

    script.push(totalText);
  }

  if (data.officeWorker) {
    let totalText = `직장인구: ${withComma(Math.round(data.officeWorker))}명`;

    if (average?.officeWorker) {
      totalText += getAverageText(
        data.officeWorker,
        average.officeWorker,
        ctprvn
      );
    }

    script.push(totalText);
  }

  if (data?.hallSales) {
    script.push(
      `분석 지역의 전체 카드 매출액 ${humanizeNumber(data.hallSales, true)}원`
    );
  }

  if (userProfile?.category) {
    const userTypeKor = USER_CATEGORIES.find(
      (i) => i.id === userProfile.category
    )?.label;

    if (userTypeKor) {
      script.push(`\n##사용자 유형##\n${userTypeKor}`);
    }
  }

  return script.join('\n');
};
